import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const RequiredColumn = styled(Flex)`
  flex: 1;
  gap: ${rem(spacing.base * 0.5)};
  justify-content: flex-end;
  align-items: center;

  svg {
    color: ${toColorString(color.status.information.medium)};
    vertical-align: middle;
  }
`;

// A horizontal rule for stacking two `Menu`s inside a single popover (KDS
// `Menu` has no built-in divider support). Unlike `components/styles`'
// `Separator` — a fixed-size vertical rule built for horizontal action rows —
// this spans the full width of the popover and separates vertically.
// `flex-shrink: 0` keeps its height inside a height-capped flex column.
export const MenuDivider = styled.div.attrs({ role: 'separator' })`
  flex-shrink: 0;
  height: ${rem(spacing.base * 0.1)};
  width: 100%;
  margin: ${rem(spacing.base * 0.5)} 0;
  background-color: ${toColorString(color.opacity.charcoal15)};
`;
